import fvObject from "../../fvObject"
import Vue from "vue"
export default class fvAnimation extends fvObject{
    constructor(shape,animationName){
        super();
        this.shape = shape;
        this.type = animationName;
        this.mixin(shape.animation[animationName]);
        this.dialog = new Vue({
            methods: {
                show (data) {
                    //修改弹窗层级以2000开始，iview默认值以1000
                    this.$Modal.props.zIndex.default = 2000;
                    this.$Modal.confirm(data);
                }
            }
        });
    }
    //动画执行接口
    run(){
        //console.warn(this.type + " 没有实现动画执行函数");
    }

    runVue(canvas){
        if(this.type == "fvVerticalMove" || this.type == "fvHorMove" || this.type == "fvRotateMove"){
            if(this.type == "fvRotateMove"){
               for (var p in this.shape.subObjects) {
                    if(this.shape.subObjects[p]){
                        if(this.shape.subObjects[p].$ && this.shape.subObjects[p].$.fctype == "fvButton"){
                            return;
                        }
                    }
                }; 
            }
            this.runEx(canvas)
        }else{
            this.run(canvas);
        }
    }

    runEx(canvas){

    }

    getEventType(e){
        if(e == "pointerdown" || e == "mousedown" || e == "touchstart" || e == "MSPointerDown"){
            return "down";
        }

        if(e == "pointerup" || e == "mouseup" || e == "MSPointerUp"){
            return "up";
        }

        if(e == "pointermove" || e == "mousemove" || e == "MSPointerMove"){
            return "move";
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvAnimation.js